import { Box, styled } from '@mui/material';
import { APPROVAL_TABLE_BORDER } from '@/components/Approval/@components/ApprovalFormTable';

export const BP_REMARK_MOBILE_WIDTH = 240;

// 이보다 좁은 PC 폭은 표 안 가로 스크롤
const BP_DETAIL_PC_MIN_WIDTH = 600;

/** 레거시 #selectedPartnerInfoTable — 왼쪽 항목명, 오른쪽 입력. 좁은 화면은 위아래로 */
export const BpInfoTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  // 안쪽 표가 넓으면 본문 전체가 아니라 그 표만 가로 스크롤
  tableLayout: 'fixed',
  fontSize: 14,
  lineHeight: '20px',
  color: 'var(--dk-text, #1A1A1A)',
  '& > tbody > tr > th, & > tbody > tr > td': {
    border: `1px solid ${APPROVAL_TABLE_BORDER}`,
    verticalAlign: 'middle',
  },
  '& > tbody > tr > th': {
    width: '20%',
    minWidth: 113,
    padding: '8px 12px',
    backgroundColor: '#F9FAFB',
    fontWeight: 500,
    textAlign: 'center',
    wordBreak: 'keep-all',
  },
  '& > tbody > tr > td': {
    padding: 12,
    backgroundColor: 'var(--dk-bg, #FFF)',
  },
  '& > colgroup': { display: 'none' },
  // 칸이 셋뿐이라 모바일에서도 화면 폭에 맞춤
  '& .approval-form-table.bp-fit': { minWidth: 0 },
  // 고정 px 합이 PC 표 폭을 넘으면 비고 칸이 0 이 되고 표 안 가로 스크롤이 생김
  '& .bp-detail col': { width: 'var(--bp-col-pc)' },
  '& .approval-form-table.bp-detail': { minWidth: BP_DETAIL_PC_MIN_WIDTH },
  [theme.breakpoints.down('md')]: {
    '&, & > tbody, & > tbody > tr, & > tbody > tr > th, & > tbody > tr > td': {
      display: 'block',
      width: '100%',
      boxSizing: 'border-box',
    },
    '& > tbody > tr > th': { textAlign: 'left', borderBottom: 0 },
    '& > tbody > tr + tr > th': { borderTop: 0 },
    '& > tbody > tr > td': { borderTop: 0 },
    // 가로 스크롤 안에서도 비고 한 칸이 가장 작은 휴대폰 화면에 다 보이게
    '& .approval-form-table.bp-detail': {
      minWidth: `calc(var(--bp-fixed-width) + ${BP_REMARK_MOBILE_WIDTH}px)`,
    },
    '& .bp-detail col': { width: 'var(--bp-col)' },
    '& .bp-detail col.bp-remark': { width: BP_REMARK_MOBILE_WIDTH },
  },
}));

/** 레거시 .guide-text */
export const BpGuideText = styled('p')`
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 18px;
  color: var(--dk-text-secondary, #888d96);
`;

export const BpCellStack = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** 라디오 아래 붙는 입력칸(레거시 .full-row.ml-20) */
export const BpIndentedField = styled(Box)`
  margin-left: 28px;
`;

export const BpRadioRow = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
`;

/** 저장 HTML 의 레거시 유틸 class 보충 */
export const BpViewRoot = styled(Box)`
  & .guide {
    margin-bottom: 8px;
  }
  & .d-flex {
    display: flex;
  }
  & .flex-column {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  & .flex-wrap {
    flex-wrap: wrap;
    gap: 8px 24px;
  }
  /* 옛 저장 HTML 의 라디오 옆 입력칸 */
  & .d-flex > .md {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
  }
  & .full-row.ml-20 {
    align-self: stretch;
    margin: 4px 0 0 28px;
  }
  & .mt-5 {
    margin-top: 8px;
  }
  & .text-center {
    text-align: center;
  }
  & td > label:not(.radio) {
    display: block;
    margin-bottom: 6px;
  }
  & .approval-form-table-scroll {
    margin-top: 8px;
  }
`;
